// extracted by mini-css-extract-plugin
export default {"next_order":"mu","recurringdis":"nu","reactivate_button":"ou","order__summary_title":"pu","order__summary_items":"qu","order__summary_item":"ru","order__summary_item_title":"su","order__summary_item_quantity":"tu","order__item_separator":"uu","discount":"vu","promowrapper":"wu"};
    if(module.hot) {
      // 1714422952967
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  